interface Data {
  comics: Comic[];
}

interface Comic {
  id: number;
  posted: string;
}

export const data: Data = {
  comics: [
    {
      id: 1,
      posted: "2016-01-13",
    },
    {
      id: 2,
      posted: "2016-01-14",
    },
    {
      id: 3,
      posted: "2016-01-15",
    },
    {
      id: 4,
      posted: "2016-01-16",
    },
    {
      id: 5,
      posted: "2016-01-17",
    },
    {
      id: 6,
      posted: "2016-01-18",
    },
    {
      id: 7,
      posted: "2016-01-19",
    },
    {
      id: 8,
      posted: "2016-01-20",
    },
    {
      id: 9,
      posted: "2016-01-21",
    },
    {
      id: 10,
      posted: "2016-01-22",
    },
    {
      id: 11,
      posted: "2016-01-25",
    },
    {
      id: 12,
      posted: "2016-01-26",
    },
    {
      id: 13,
      posted: "2016-01-27",
    },
    {
      id: 14,
      posted: "2016-01-28",
    },
    {
      id: 15,
      posted: "2016-01-29",
    },
    {
      id: 16,
      posted: "2016-02-01",
    },
    {
      id: 17,
      posted: "2016-02-02",
    },
    {
      id: 18,
      posted: "2016-02-03",
    },
    {
      id: 19,
      posted: "2016-02-04",
    },
    {
      id: 20,
      posted: "2016-02-08",
    },
    {
      id: 21,
      posted: "2016-02-09",
    },
    {
      id: 22,
      posted: "2016-02-10",
    },
    {
      id: 23,
      posted: "2016-02-12",
    },
    {
      id: 24,
      posted: "2016-02-16",
    },
    {
      id: 25,
      posted: "2016-02-17",
    },
    {
      id: 26,
      posted: "2016-02-18",
    },
    {
      id: 27,
      posted: "2016-02-22",
    },
  ],
};
